import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';
import '../styles/ThankYouPage.css';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const [counter, setCounter] = useState(5);

  useEffect(() => {
    if (!user) {
      navigate('/');
      return;
    }

    const countdown = setInterval(() => {
      setCounter((prevCounter) => prevCounter - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      logout();
      navigate('/');
    }, 5000);

    return () => {
      clearInterval(countdown);
      clearTimeout(timeout);
    };
  }, [user, logout, navigate]);

  return (
    <div className="thankyou-container">
      <h1>Vielen Dank für die Teilnahme an der Umfrage!</h1>
      <p className="redirect-message">Sie werden in {counter} Sekunden zur Anmeldeseite weitergeleitet.</p>
    </div>
  );
};

export default ThankYouPage;